import React, { useEffect, useState } from 'react';
import api from '../api/axios';

const roleCfg = { super_admin:{label:'Super Admin',color:'bg-purple-100 text-purple-700',icon:'👑'}, office_sales:{label:'Ofis Satış',color:'bg-blue-100 text-blue-700',icon:'🏢'}, field_sales:{label:'Saha Satış',color:'bg-emerald-100 text-emerald-700',icon:'🚗'} };
const ef = {full_name:'',email:'',password:'',role:'office_sales',region:''};

export default function Users() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(ef);
  const [loading, setLoading] = useState(false);

  const load = () => api.get('/users').then(r=>setUsers(r.data));
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/users', form); setShowForm(false); setForm(ef); load(); }
    catch(err) { const d=err.response?.data?.detail; alert('Hata: '+(Array.isArray(d)?d.map(x=>x.msg).join(', '):d||'Bu email zaten kayıtlı')); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-5 animate-fadein">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Kullanıcılar</h1>
          <p className="text-gray-500 text-sm mt-0.5">{users.length} kullanıcı</p>
        </div>
        <button onClick={() => setShowForm(true)} className="btn-primary">+ Yeni Kullanıcı</button>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowForm(false)}>
          <div className="modal animate-slideup">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-lg font-bold">Yeni Kullanıcı</h2>
              <button onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input required value={form.full_name} onChange={e=>setForm({...form,full_name:e.target.value})} className="input" placeholder="Ad Soyad *" />
              <input required type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input" placeholder="Email *" />
              <input required type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="input" placeholder="Sifre *" />
              <div className="grid grid-cols-2 gap-3">
                <select value={form.role} onChange={e=>setForm({...form,role:e.target.value})} className="input">
                  <option value="office_sales">Ofis Satış</option>
                  <option value="field_sales">Saha Satış</option>
                  <option value="super_admin">Super Admin</option>
                </select>
                <input value={form.region} onChange={e=>setForm({...form,region:e.target.value})} className="input" placeholder="Bolge" />
              </div>
              <div className="flex gap-2 pt-2">
                <button type="submit" disabled={loading} className="btn-primary flex-1">{loading ? 'Kaydediliyor...' : 'Oluştur'}</button>
                <button type="button" onClick={() => setShowForm(false)} className="btn-secondary flex-1">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {users.map(u => {
          const rc = roleCfg[u.role] || {label:u.role,color:'bg-gray-100 text-gray-600',icon:'👤'};
          return (
            <div key={u.id} className="card p-5 hover:shadow-md transition-shadow">
              <div className="flex items-start gap-3">
                <div className="w-11 h-11 rounded-2xl bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold flex-shrink-0">{u.full_name[0].toUpperCase()}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <div className="font-semibold text-gray-800 text-sm">{u.full_name}</div>
                      <div className="text-xs text-gray-400 truncate">{u.email}</div>
                    </div>
                    <span className={"text-xs font-semibold px-2 py-0.5 rounded-full flex-shrink-0 " + rc.color}>{rc.icon} {rc.label}</span>
                  </div>
                  <div className="flex items-center gap-2 mt-3">
                    {u.region && <span className="text-xs text-gray-500">📍 {u.region}</span>}
                    <span className={"ml-auto text-xs px-2 py-0.5 rounded-full " + (u.is_active ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600')}>{u.is_active ? 'Aktif' : 'Pasif'}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
